// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SignaturesOfCallToDefendMedia_Wrapper__DMhma","Signature":"SignaturesOfCallToDefendMedia_Signature__A35qq"};